export default __webpack_public_path__ + "7fbe32f5029b42f62604f7700e7b8cf4.xlsx";